import React, { useState } from 'react';
import { FiSettings, FiSave, FiCheckCircle } from 'react-icons/fi';
import ToolsSidebar from '../components/ToolsSidebar';
import useLocalState from '../hooks/useLocalState';

export default function Settings() {
  const [settings, setSettings] = useLocalState('app_settings_v1', {
    companyName: 'WY Limited',
    currency: 'HKD',
    taxRate: '0',
    pdfTemplate: 'crabe',
    address: 'Hong Kong Central District'
  });
  const [showSaved, setShowSaved] = useState(false);

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleSave = (e) => {
    e.preventDefault();
    setShowSaved(true);
    setTimeout(() => setShowSaved(false), 3000);
  };

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <ToolsSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-3 overflow-y-auto">
        <div className="flex justify-between items-center mb-4 px-1 text-gray-800">
          <div className="flex items-center space-x-2">
            <FiSettings className="text-[#0000a0] text-xl" />
            <span className="font-bold text-[16px] text-teal-800">Company Settings</span>
          </div>
          {showSaved && (
            <span className="text-green-700 font-bold text-sm flex items-center bg-green-100 px-3 py-1 rounded shadow-sm">
              <FiCheckCircle className="mr-1.5" /> Settings Saved!
            </span>
          )}
        </div>

        <div className="bg-white p-6 border border-gray-300 shadow-sm rounded-sm max-w-4xl">
          <form onSubmit={handleSave} className="space-y-6">
            {/* Company Info */}
            <div>
              <h3 className="text-[14px] font-bold text-teal-900 border-b border-gray-200 pb-2 mb-4 uppercase tracking-wide">Company Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[12px] font-bold text-gray-700 mb-1">Company Name</label>
                  <input type="text" name="companyName" value={settings.companyName} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded-sm focus:outline-none focus:border-[#0000a0] text-[13px] bg-gray-50" required />
                </div>
                <div>
                  <label className="block text-[12px] font-bold text-gray-700 mb-1">Main Address</label>
                  <input type="text" name="address" value={settings.address} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded-sm focus:outline-none focus:border-[#0000a0] text-[13px] bg-gray-50" />
                </div>
              </div>
            </div>

            {/* Financial Parameters */}
            <div>
              <h3 className="text-[14px] font-bold text-teal-900 border-b border-gray-200 pb-2 mb-4 uppercase tracking-wide">Financial Parameters</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[12px] font-bold text-gray-700 mb-1">Default Currency</label>
                  <select name="currency" value={settings.currency} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded-sm focus:outline-none focus:border-[#0000a0] text-[13px] bg-gray-50">
                    <option value="HKD">HKD - Hong Kong Dollar</option>
                    <option value="USD">USD - US Dollar</option>
                    <option value="EUR">EUR - Euro</option>
                    <option value="CNY">CNY - Chinese Yuan</option>
                  </select>
                </div>
                <div>
                  <label className="block text-[12px] font-bold text-gray-700 mb-1">Default Tax Rate (%)</label>
                  <input type="number" name="taxRate" value={settings.taxRate} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded-sm focus:outline-none focus:border-[#0000a0] text-[13px] bg-gray-50" min="0" max="100" />
                </div>
              </div>
            </div>

            {/* Document Templates */}
            <div>
              <h3 className="text-[14px] font-bold text-teal-900 border-b border-gray-200 pb-2 mb-4 uppercase tracking-wide">Document Templates</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[12px] font-bold text-gray-700 mb-1">Invoice PDF Template</label>
                  <select name="pdfTemplate" value={settings.pdfTemplate} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded-sm focus:outline-none focus:border-[#0000a0] text-[13px] bg-gray-50">
                    <option value="crabe">Crabe (Standard)</option>
                    <option value="sponge">Sponge (Detailed)</option>
                    <option value="cyan">Cyan (Modern)</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="pt-4 flex justify-end">
              <button type="submit" className="bg-[#0000a0] text-white px-6 py-2 rounded-sm font-bold text-[13px] shadow-sm hover:bg-blue-900 transition-colors flex items-center">
                <FiSave className="mr-2" /> SAVE SETTINGS
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}